import {Injectable} from '@angular/core';
import {LoadingController, Platform, ToastController} from '@ionic/angular';
import {StorageService} from '../storage-service/storage.service';
import {ApiService} from '../api-service/api.service';
import {API_ENDPOINT, ENDPOINT} from '../../../environments/environment';
import {ErrorService} from '../error-service/error.service';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {InAppBrowser} from '@ionic-native/in-app-browser/ngx';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    
    private isFirstCycleAnnouncedSource = new Subject();
    isFirstCycle$ = this.isFirstCycleAnnouncedSource.asObservable();
    
    loader: HTMLIonLoadingElement;
    toast: HTMLIonToastElement;
    isApp: boolean;
    
    constructor(public loadingCtrl: LoadingController,
                public toastCtrl: ToastController,
                private storageService: StorageService,
                private errorService: ErrorService,
                private api: ApiService,
                private router: Router,
                private platform: Platform,
                private iab: InAppBrowser) {

        this.platform.ready().then(() => {
            this.isApp = !(this.platform.is('mobileweb') || this.platform.is('desktop'));
        });
    }
    
    publishisFirstCycle(data: boolean) {
        this.isFirstCycleAnnouncedSource.next(data);
    }
    
    async presentLoader(msg: string = '') {
        this.loader = await this.loadingCtrl.create({
            message: msg,
            duration: 5000
        });
        await this.loader.present();
    }
    
    async dismissLoader() {
        console.log('--------------- dismissLoader -------------------: ', this.loader);
        if (this.loader != null) {
            await this.loadingCtrl.dismiss();
            this.loader = null;
        }
        return;
    }
    
    getLocalNotificationSettings(): object {
        
        const storageItem = 'sympto.notifications';
        const localNotes = localStorage.getItem(storageItem);
        
        if (!localNotes) {
            // Set Defaults
            const notificationObj = {
                text: 'Hallo, denk bitte an Deine Eintragungen im Zyklusblatt. Einen schönen Tag wünsche ich Dir.',
                hour: 7,
                minute: 0,
                sound: true,
                notifications: true
            };
            localStorage.setItem(storageItem, JSON.stringify(notificationObj));
        } else {
            console.log('Default für LocalStorage gesetzt');
        }
        
        return JSON.parse(localNotes);
    }
    
    async presentToast(msg: string, pos = 'middle', dur: number = 2000) {
        const options: any = {
            message: msg,
            position: pos,
            duration: dur
        };
        this.toast = await this.toastCtrl.create(options);
        
        await this.toast.present();
    }
    
    async presentToastConfirm(msg: string, pos = 'middle', dur?: number) {
        
        try {
            this.toast.dismiss();
        } catch (e) {
            console.log('presentToastConfirm error dismiss: ', e);
        }
        
        const options: any = {
            message: msg,
            position: pos,
            buttons: ['Ok'],
            cssClass: 'toast-confirm'
        };
        
        if (dur) {
            options.duration = dur;
        }
        
        this.toast = await this.toastCtrl.create(options);
        
        await this.toast.present();
    }
    
    downloadCyclePDF(path: string) {
        const cleanPath = (path[0] === '/') ? path.substr(1) : path;
        const token = this.storageService.getToken();
        if (this.platform.is('ios') || this.platform.is('android')) {
            this.platform.ready().then(() => {
                this.iab.create(ENDPOINT + cleanPath + '&token=' + token + '&isApp=' + this.isApp, '_system');
            });
        } else {
            window.open(ENDPOINT + cleanPath + '&token=' + token + '&isApp=' + this.isApp, '_system');
        }
    }
    
    replaceImageMarker(text: string): string {
        try {
            text = text.replace(/#trait#/gi, '<ion-icon class="sympto-replace-icon blue" src="assets/icons/sympto/in-text/elixier_1_cut.svg"></ion-icon>');
            text = text.replace(/#batonbleu#/gi, '<ion-icon class="sympto-replace-icon blue" src="assets/icons/sympto/in-text/elixier_2_cut.svg"></ion-icon>');
            text = text.replace(/#batonlong#/gi, '<ion-icon class="sympto-replace-icon blue" src="assets/icons/sympto/in-text/elixier_3_cut.svg"></ion-icon>');
            text = text.replace(/#tachejaune#/gi, '<ion-icon class="sympto-replace-icon yellow" src="assets/icons/sympto/in-text/elixier_4_cut.svg"></ion-icon>');
            text = text.replace(/#goutte1#/gi, '<ion-icon class="sympto-replace-icon red" src="assets/icons/sympto/in-text/bleeding_1_cut.svg"></ion-icon>');
            text = text.replace(/#goutte2#/gi, '<ion-icon class="sympto-replace-icon red" src="assets/icons/sympto/in-text/bleeding_2_cut.svg"></ion-icon>');
            text = text.replace(/#goutte3#/gi, '<ion-icon class="sympto-replace-icon red" src="assets/icons/sympto/in-text/bleeding_3_cut.svg"></ion-icon>');
            text = text.replace(/#sympto#/gi, '<i>sympto</i>');

            return text;
        } catch (e) {
            return '';
        }
    }
    
    getCycleList(token: string) {
        let sessionId = '';
        sessionId = this.storageService.getSessionId();
        this.api.getData('cycles_new', token, sessionId).subscribe(
            (result) => {
                console.log('getCycleList: ', result);
                this.storageService.setCyleList(result.body.cycles);
                this.storageService.setCycleListTitle(result.body.title);
            }, (error) => {
                console.log('getCycleList error: ', error);
            });
    }
    
    refreshCycleList(token) {
        let sessionId = '';
        sessionId = this.storageService.getSessionId();
        this.api.getData('calc', token, sessionId).subscribe(
            (result) => {
                try {
                    if (result.body) {
                        this.getCycleList(token);
                    }
                } catch (e) {
                    this.errorService.handleError(e, 'getData error');
                }
            }, (error) => {
                this.errorService.handleError(error, 'getData error');
            });
    }
}
